<template>
  <div class="main-container package-content">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <span class="current">套卷练习</span>
    </div>
    <list
      class="list"
      :autoGetData="false"
      ref="list"
      url="/api/app/practice/package"
      :limit="16"
      :search="search"
    >
      <template v-slot="{ list }">
        <div class="package-list clearfix">
          <template v-for="item in list">
            <div
              class="package"
              :key="item.id"
              @click="
                $router.push({
                  name: 'ExamPackagePaper',
                  query: { id: item.id },
                })
              "
            >
              <div style="font-size: 0">
                <span class="name">共{{ item.exams_count }}套</span>
                <span class="divider">|</span>
                <span class="name">
                  {{ item.name }}
                </span>
              </div>
              <div class="bottom">
                <span class="num">{{ item.practiceNum }}人已练习</span>
                <span
                  class="count"
                  v-if="
                    item.show.type == 1 ||
                    item.show.type == 2 ||
                    item.show.type == 3 ||
                    item.show.type == 6
                  "
                >
                  <img
                    class="vip-logo"
                    src="@/assets/images/vip/vip-free.png"
                    alt=""
                    v-if="item.show.type == 6"
                  />
                  <span class="vip_price">
                    <CurrencyNew
                      :showFreeText="item.show.type != 6 && item.show.type != 1"
                      :price="item.show.price || 0"
                      :priceTwo="true"
                      :isUnderlineLeft="false"
                    ></CurrencyNew>
                    <span class="start" v-if="item.show.type == 1 || item.show.type == 6">
                      起
                    </span>
                  </span>
                </span>
                <span class="link" v-if="item.show.type == 5">了解详情</span>
              </div>
              <img
                v-if="item.show.type == 4"
                class="img"
                src="@/assets/images/vip/deblock.png"
                alt=""
              />
            </div>
          </template>
        </div>
        <Empty v-if="list.length == 0" class="empty" title="暂无套卷练习，敬请期待！" />
      </template>
    </list>
  </div>
</template>
<script>
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamPackage',
  components: { ExamIndexBread },
  data() {
    return {
      search: {
        attr_val_id: '',
      },
    };
  },
  async created() {
    this.search.attr_val_id = await this.$services.ExamService.getAttrValId();
    this.$refs.list.searchRefresh();
  },
};
</script>
<style lang="scss" scoped>
.package {
  position: relative;
  width: 280px;
  height: 158px;
  padding: 20px 23px 17px 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  margin: 0 26px 26px 0;
  float: left;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  &:nth-child(4n) {
    margin-right: 0;
  }

  .name {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    //line-height: 24px;
    //font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    //text-align: LEFT;
    color: #333333;
    line-height: 22px;
    vertical-align: middle;
  }
  .divider {
    font-size: 12px;
    padding: 0 4px 0 8px;
    position: relative;
    vertical-align: middle;
    top: -1px;
    color: #ccc;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .num {
    font-size: 14px;
    //line-height: 1;

    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }

  .count {
    font-size: 14px;
    color: $primary-color;
    //line-height: 1;
    .price-wrap {
      display: inline-block;
    }
    .start {
      display: inline-block;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: $primary-color;
      margin-left: 2px;
      //line-height: 20px;
    }
    .vip-logo {
      width: 83px;
      height: 24px;
      margin-right: 4px;
      display: inline-block;
      vertical-align: top;
    }
    .vip_price {
      display: inline-block;
      vertical-align: top;
      margin-top: 3px;
    }
  }
  .link {
    display: inline-block;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: $primary-color;
    line-height: 22px;
    cursor: pointer;
  }
  .img {
    position: absolute;
    width: 64px;
    height: 64px;
    right: 20px;
    bottom: 13px;
  }
}
.package-content {
  margin-bottom: 40px;
}
</style>
